import styled from "styled-components";
import {useState} from "react";
import {toast} from "react-toastify";
import {schemas} from "../../config";
import {act343PrizeMap, inmsg343PortalFilters, inmsg343Ps5Filters, inmsg343SilpoFilters} from "../InmsgTable";
import {FieldMapValue} from "../../Types";
import {LANG} from "../../components/CONSTANTS";
import {useAppDispatch} from "../../hooks";
import {fetchTableByQuery, setTableFilters} from "../../features/tableSlice";


export default function SetWinners() {

    const [selectedPrize, setSelectedPrize] = useState<FieldMapValue | null>(null)
    const [ids, setIds] = useState("")
    const [sending, setSending] = useState(false);

    const schema = schemas['act343']

    const dispatch = useAppDispatch();

    function changeSelectedPrizeFilters(prizeId: string) {
        if (prizeId === '1')
            dispatch(setTableFilters(inmsg343SilpoFilters() as any))

        if (prizeId === '2')
            dispatch(setTableFilters(inmsg343PortalFilters() as any))

        if (prizeId === '3')
            dispatch(setTableFilters(inmsg343Ps5Filters() as any))

        dispatch(fetchTableByQuery({clean: true, pageIndex: 1}))
    }

    function send() {
        setSending(true)
        toast.info("Відправляємо емейли. Може зайняти певний час...")
        fetch(
            `${schema.backend}/343/setWinners.php`,
            {
                credentials: 'include',
                method: "POST",
                body: JSON.stringify({ids: ids, prizeId: selectedPrize!.rawValue, prizeText: selectedPrize!.lang[LANG]})
            })
            // .then(handleFetchResponseStatus)
            .then(r => r.json())
            .then(r => {
                if (r.have_error)
                    toast.error("Деякі емейли не були відправлені")
                if (r.error === true) {
                    toast.error(r.errorBody || "Сталась помилка при розсилці")
                } else {
                    toast.info("Емейли були відправлені переможцям. Оновіть таблицю")
                }
                setSending(false)
            })
    }

    return <Container>
        <label htmlFor="ids">Список ID ПЕРЕМОЖЦІВ через кому</label>
        <input type="text" id={"ids"} value={ids} placeholder={"2,45,78,123,54"}
               onChange={(e) => setIds(e.target.value)}/>
        <select name="prizes" id="prizes" value={selectedPrize?.rawValue || ''}
                onChange={(e) => {
                    setSelectedPrize(act343PrizeMap.values[e.target.value])
                    changeSelectedPrizeFilters(e.target.value)
                }}>
            {!selectedPrize && <option value="">Оберіть приз...</option>}
            {Object.values(act343PrizeMap.values).map(p => <option value={p.rawValue} key={p.rawValue}>
                {p.lang[LANG]}
            </option>)}
        </select>
        <button className="btn-cmn" onClick={send} disabled={sending || !selectedPrize}>
            Підтвердити
        </button>
        <div>Переможцям буде надіслано емейл, якщо ще не було</div>

        <div className="email">
            <div>Вітаємо з виграшем!</div>
            <div>Ти став переможцем акції «Пшшш! Хрум! І вперед за призом!» та виграв приз
                 – {selectedPrize?.lang[LANG]}.
            </div>
            <div>Щоб ми могли надіслати вам приз, потрібно надати документи, зазначені в правилах акції:</div>
            <div>1. Копія паспорта (1, 2 сторінки та сторінка з місцем реєстрації) або ID-картка з витягом.</div>
            <div>2. Копія ІПН (індивідуального податкового номера).</div>
            <div>3. Фото виграшного чеку</div>
            <div>4. Актуальна адреса відділення Нової пошти, куди потрібно відправити приз. (ПІБ та номер телефону мають
                 бути лише переможця) (<i>прим.</i> - окрім елек. сертифікату)
            </div>
            <div>Документи необхідно надіслати протягом 3 робочих днів з моменту отримання цього повідомлення.</div>
            <div>Надсилати їх потрібно на e-mail relicate_2022@ukr.net</div>
            <div>Як тільки отримаємо від вас усі документи, ми перевіримо і вишлемо ваш приз протягом 30 календарних
                 днів.
            </div>
            <div> Щиро вітаємо ще раз!
            </div>
            <div> Дякуємо, що взяли участь у нашій акції.
            </div>
        </div>


    </Container>
}

const Container = styled.div`
    display: flex;
    width: 100%;
    background: var(--table-row-odd-bg-color);
    color: var(--table-row-text-color);
    padding: .5rem;
    border-radius: .5rem;
    justify-content: center;
    align-items: center;
    gap: .5rem;
    flex-flow: column;

    & input, select, button {
        width: 100%;
        max-width: 600px;

    }

    & .email {
        word-break: normal;
        line-height: 1.4;
    }
`
